export default __webpack_public_path__ + "static/media/1692.6c19886a.png";